import { useAdvanceQuestion } from './hooks';
import { AdvanceQuestionTemplate } from 'views/components/templates/establishes';
import { Gauge, GaugeSP, getGaugeValue } from 'views/components/atoms/gauge';
import { useLocation } from 'react-router-dom';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { useState } from 'react';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';
import { localStorage } from 'views/utils/localStrage/localStrageUtil';
import { OpenAccountParamKey } from 'views/constants/const/AccountOpen';

export const AdvanceQuestion = () => {
  const tempProps = useAdvanceQuestion();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState<boolean>(localStorage.contains(OpenAccountParamKey));

  return (
    <form className="establishFormSP" onSubmit={tempProps.formik.handleSubmit}>
      <GaugeSP currentPage={getGaugeValue(location.pathname)} />
      <ModalBase
        isOpen={isOpen}
        modalStyle={ModalStyle.confirmModal}
        children={
          <div className="modalWrapper">
            <span className="finishLabel">保存された入力があります復元しますか？</span>
            <Button
              label="閉じる"
              onClick={() => setIsOpen(false)}
              fillType={FillType.primaryEmpty}
              buttonSize={ButtonSize.sizeM}
            />
            <Button
              label="復元する"
              onClick={() => {
                tempProps.loadOpenAccount();
                setIsOpen(false);
              }}
              fillType={FillType.primaryFill}
              buttonSize={ButtonSize.sizeM}
            />
          </div>
        }
      />
      <AdvanceQuestionTemplate {...tempProps} />
    </form>
  );
};
